import React from "react";
import { withTranslation } from "react-i18next";
import InstanceStatus from "../../../../../helpers/InstanceStatus";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ExaminationInstanceStatusCell = props => (
  <b>
    {InstanceStatus.inTransition(props.code) ? (
      <FontAwesomeIcon icon={faCircleNotch} spin className="mr-2" />
    ) : (
      ""
    )}
    {props.t(InstanceStatus.getTranslationByStatus(props.code))}
  </b>
);

export default withTranslation()(ExaminationInstanceStatusCell);
